import React from 'react';
import { connect } from 'react-redux'
import { showAddress, setPaymentMethod } from '../actions'

class ContributionChoiceForm extends React.Component {
  constructor(props) {
    super(props)
    this.handleETHMethod = this.handleETHMethod.bind(this)
    this.handleBTCMethod = this.handleBTCMethod.bind(this)
  }

  handleETHMethod() {
    const { showAddress, setPaymentMethod } = this.props
    setPaymentMethod({
      name: 'ETH',
      image: 'ethereum.png'
    })
    showAddress()
  }

  handleBTCMethod() {
    const { showAddress, setPaymentMethod } = this.props
    setPaymentMethod({
      name: 'BTC',
      image: 'bitcoin.png'
    })
    showAddress()
  }

  render () {
    return (
      <div className="ContributionBox">
        <div className="FormGroup">
          <div className="suggestion blue box">
            <span className="warning"><p>Reminder</p></span>
            <span>Do not send funds from an exchange</span>
          </div>

          <div className="PaymentOptions">
            {/* This button can be a presentational component */}
            <button className="PaymentMethod" onClick={this.handleETHMethod}>
              <div className="icon"><img src="/ethereum.png" alt="ETH"/></div>
              <div className="name">ETH</div>
              <div className="conversion">
                <p>1 ETH : 1,000 IND</p>
              </div>
              <div className="helper">
                <p>Minimum contribution 100 ETH</p>
              </div>
            </button>
            <button className="PaymentMethod" onClick={this.handleBTCMethod}>
              <div className="icon"><img src="/bitcoin.png" alt="BTC"/></div>
              <div className="name">BTC</div>
              <div className="conversion">
                <p>10 BTC : 2,972.21 PAY</p>
              </div>
              <div className="helper">
                <p>Minimum contribution 17.664 BTC</p>
              </div>
            </button>
          </div>

          {/* <div className="note"><p>This rate is not final. The final rate will depend on
            the time of your transaction gets confirmed on the blockchain</p></div> */}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {  }
}

export default connect(
  mapStateToProps,
  { showAddress, setPaymentMethod }
)(ContributionChoiceForm)


// WEBPACK FOOTER //
// ./src/containers/ContributionChoiceForm.jsx